export default "__VITE_ASSET__DTgMPZ2H__"